module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.6.2/_next/static/images/correios-43ca39d54f323a269c01def689ab60d9.png";